import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, TemplateRef } from '@angular/core';
import { DsButtonModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { useI18n } from '../../i18n/services/i18n.service';
import { ButtonRowComponent } from '../button/button-row.component';

@Component({
  selector: 'cdf-verify-choice-modal',
  imports: [DsButtonModule, DsTooltipDirectiveModule, NgTemplateOutlet, ButtonRowComponent],
  template: `
    @if (bodyTemplate()) {
      <ng-container *ngTemplateOutlet="bodyTemplate()" />
    } @else if (bodyText()) {
      <span>
        {{ bodyText() }}
      </span>
    }

    <cdf-button-row class="mt-4x">
      @if (displayCancelButton()) {
        <ds-button id="cancel-button" variant="ghost" (click)="closeModal.emit()" [disabled]="buttonLoading()">
          {{ cancelButtonText() ?? i18n('button.cancel') }}
        </ds-button>
      }
      <ds-button
        ds-loading
        id="verify-button"
        (click)="verify.emit()"
        [isLoading]="buttonLoading()"
        [disabled]="disableVerifyButton()"
        [ds-tooltip]="i18n('readonlyTooltip')"
        [dsTooltipConfig]="{ disabled: !disableVerifyButton(), origin: 'bottom', showTriggerDelay: 500 }"
        [variant]="isDestructiveAction() ? 'destructive' : 'primary'"
      >
        {{ verifyButtonText() }}
      </ds-button>
    </cdf-button-row>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyChoiceModalComponent {
  protected readonly i18n = useI18n();

  readonly closeModal = output();
  readonly verify = output();

  readonly verifyButtonText = input.required<string>();
  readonly cancelButtonText = input<string>();
  readonly buttonLoading = input(false);
  readonly displayCancelButton = input(true);
  readonly disableVerifyButton = input(false);
  readonly bodyText = input<string | TemplateRef<unknown>>();
  readonly isDestructiveAction = input(false);

  protected readonly bodyTemplate = computed(() => {
    const bodyText = this.bodyText();
    return bodyText instanceof TemplateRef ? bodyText : null;
  });
}
